import { InjectionToken } from '@angular/core';

import { UnleashConfig } from './internal';

export const UnleashConfigToken = new InjectionToken<UnleashConfig>(
	'unleashConfig'
);
